<template>
  <FocusTrap>
    <div class="card"  id="mycard" >

    <div class="card-header bg-transparent header-elements-sm-inline py-sm-0">

      <h5 class="card-title py-sm-3"><span class="icon-list"></span>&nbsp;&nbsp;Buyer's List</h5>

      <div class="header-elements">
        <form action="#">
          <div class="form-group-feedback form-group-feedback-right">
            <input  id="txtsearch" type="search" class="form-control wmin-sm-200" placeholder="Search..." autocomplete="off">
            <div class="form-control-feedback">
              <i class="icon-search4 font-size-base text-muted"></i>
            </div>
          </div>
        </form>

      </div>
    </div>


    <div class="table-responsive">
      <table id="buyer-table"
             class="table table-bordered table-columned"
             data-search="false"
             data-pagination="true"
             data-show-refresh="false"
             data-show-columns="false"
             data-page-list="[10, 25, 50, 100, ALL]"
             data-show-footer="false"
             data-toggle="context"
             data-target=".context-table">
        <thead>
        <tr>
          <th data-field="id" data-class="d-none">id</th>
          <th data-field="id" data-class="d-none"data-width="100" >Code</th>
          <th data-formatter="runningFormatter" data-width="75" >S.No</th>
          <th data-field="name" >Name</th>
          <th data-field="city" >City</th>
          <th data-field="pin" >Pincode</th>
          <th data-field="gstin" >GSTIN</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
        <tfoot>
        </tfoot>
      </table>
    </div>

    <!-- Context Menu -->
    <div id="context-menu" class="context-table">
      <div class="dropdown-menu">
        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset" style="color: darkgreen"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"> <i class="icon-pencil3" ></i>Modify</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"> <i class="icon-blocked text-danger" ></i>Remove</a>
      </div>
    </div>
    <!-- End of Context Menu -->

    <!-- Clickable menu -->
    <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover" z-index="0">
      <li>
        <a class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showModal">
          <i class="fab-icon-open icon-plus3"></i>
          <i class="fab-icon-close icon-plus3"></i>
        </a>
      </li>
    </ul>
    <!-- /clickable menu -->

    <FocusTrap>
      <vmodal name="buyer_window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="900" :height="580" @before-open="beforeOpen" @before-close="beforeClose" >
        <BuyerForm v-bind:mybuyer="buyer" v-on:buyer_window_closed="closeModal" v-on:buyer_saved="loadData" ></BuyerForm>
      </vmodal>
    </FocusTrap>

  </div>
  </FocusTrap>
</template>

<script>
  // import BuyerForm from '@/components/v1/buyer/BuyerForm.vue'
  import BuyerForm from './BuyerForm';
  import {userService} from '@/store/auth-header.js'

  export default {
    name: 'BuyerView',
    components: {
      BuyerForm
    },
    data () {
      return {
        mytable: {},
        buyer: JSON.parse('{"id":0,"status":"","type":0,"name":"","add1":"","add2":"","city":"","pin":"","state_cd":33,"country_cd":"IN","tel":"","mobile":"","email":"","web":"","gstin":"","open_bal":0}'),
      }
    },
    created () {

    },
    mounted () {
      const self = this;

      this.$data.mytable = $('#buyer-table');

      this.$data.mytable.bootstrapTable();
      $('[data-toggle="popover"]').popover();

      this.$data.mytable.contextmenu({
        target: '#context-menu',
        scopes: 'tbody > tr',
        onItem: function (row, e) {
          var id = $(row.children('*')[0]).text();

          if ($(e.target).text() === 'Modify') {
            self.modifyDocument (id);
          } else if ($(e.target).text() === 'Remove') {
            self.removeDocument(id);
          }
        }
      });

      $('#txtsearch').keyup(function () {
        let val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase()
        $('#buyer-table>tbody>tr').show().filter(function () {
          let text = $(this).text().replace(/\s+/g, ' ').toLowerCase()
          return !~text.indexOf(val)
        }).hide();
      });

      self.loadData();
    },
    methods: {
      closeModal () {
        this.$modal.hide('buyer_window');
      },
      showModal () {
        this.$modal.show('buyer_window');
      },
      beforeOpen(){
        console.log('beforeOpen');
      },
      beforeClose(){
        // this.loadData();
        this.buyer = JSON.parse('{"id":0,"status":"","type":0,"name":"","add1":"","add2":"","city":"","pin":"","state_cd":33,"country_cd":"IN","tel":"","mobile":"","email":"","web":"","gstin":"","open_bal":0}');
      },
      loadData () {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        block_el('#mycard');
        this.$modal.hide('buyer_window');
        self.$data.mytable.bootstrapTable('load',[]);

        fetch(`${process.env.VUE_APP_ROOT_API}api/buyers`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if( _.isArray(resp.data)){
              self.$data.mytable.bootstrapTable('load', resp.data);
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(()=>{
          unblock_el('#mycard');
        });

      },
      modifyDocument (id) {
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };


        self.$data.buyer = JSON.parse('{"id":0,"status":"","type":0,"name":"","add1":"","add2":"","city":"","pin":"","state_cd":33,"country_cd":"IN","tel":"","mobile":"","email":"","web":"","gstin":"","open_bal":0}');

        fetch(`${process.env.VUE_APP_ROOT_API}api/buyer/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            self.$data.buyer = resp.data;
            self.$modal.show('buyer_window');
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text:  err.toString() , type:  "error"} );
        });
      },
      removeDocument (id) {
        const self = this;

        self.$data.buyer.id = id;

        const requestOptions = {
          method: 'DELETE',
          mode:'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.buyer)
        };

        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          timer: 3000,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete Buyer!'
        }).then((result) => {
          if (result.value) {
            fetch(`${process.env.VUE_APP_ROOT_API}api/buyer/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
              self.$modal.hide('buyer_window')
              self.loadData();
              swal(
                'Deleted!',
                'Your request has been processed',
                'success'
              );
            }).catch(function (err) {
              swal({ title: "Oops", text: err.toString(), type: "error" });
            });
          }
        });
      },

    }
  }
</script>

<style scoped>

</style>
